import { http } from 'globalState/global-state.js';

export const putLastInfo = params => {
    return http.xmlUnsafeRequest.post('/cart/order/api/setLastInfo/', params);
};

export const getLastInfo = params => {
    return http.xmlUnsafeRequest.get('/cart/order/api/lastInfo/', {
        params,
    });
};
